import React from 'react';
import { Dropdown, FormControl } from 'react-bootstrap';

const SelectFileDropdown = ({ containerFiles, onFileSelect, selectedContainerFiles, disabled, loadingContainerFiles }) => {
  const [searchTerm, setSearchTerm] = React.useState('');

  const filteredFiles = containerFiles.filter(file =>
    file.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    file.folder_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    file.full_path?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (fileId) => {
    const file = containerFiles.find(f => f.id.toString() === fileId);
    if (file) {
      onFileSelect(file);
    }
  };

  const getPlaceholder = () => {
    if (disabled && !loadingContainerFiles) return 'Select File';
    if (loadingContainerFiles) return 'Loading files...';
    if (containerFiles.length === 0) return 'No files available';
    return 'Select File';
  };

  return (
    <div className="select-file-dropdown-wrapper">
      <Dropdown
        onSelect={handleSelect}
        disabled={disabled || loadingContainerFiles}
        autoClose="outside"
      >
        <Dropdown.Toggle
          variant="light"
          id="dropdown-select-file"
          className="w-100 d-flex justify-content-between align-items-center"
          disabled={disabled || loadingContainerFiles}
        >
          <span>{getPlaceholder()}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-auto-width">
          {containerFiles.length > 0 && (
            <>
              <div className="px-3 py-2">
                <FormControl
                  autoFocus
                  placeholder="Search files..."
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                />
              </div>
              <Dropdown.Divider />
            </>
          )}

          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {filteredFiles.length === 0 ? (
              <Dropdown.Item disabled>
                {loadingContainerFiles ? 'Loading files...' : 'No files found'}
              </Dropdown.Item>
            ) : (
              filteredFiles.map(file => (
                <Dropdown.Item
                  key={file.id}
                  eventKey={file.id.toString()}
                  as="div"
                  title={file.name}
                  style={{
                    width: '100%',
                    display: 'block',
                    whiteSpace: 'nowrap',
                    overflowX: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer'
                  }}
                  onDragStart={(e) => e.preventDefault()}
                  className={selectedContainerFiles.some(sf => sf.id === file.id) ? 'selected-container-file' : ''}
                >
                  {file.full_path?.replace(/^\//, '')}
                </Dropdown.Item>
              ))
            )}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default SelectFileDropdown;